













import Vue from 'vue'
import { Jodit, IJodit, markerInfo } from 'jodit'
import { Multimedia } from '@/model/Multimedia'
import 'jodit/build/jodit.min.css'
import AddImageDialog from '@/components/project/AddImageDialog.vue'
import AddMovieDialog from '@/components/project/AddMovieDialog.vue'
import Youtube from '@/service/Youtube'
import sanitizeHtml from 'sanitize-html'

export default Vue.extend({
  name: 'ProjectDescriptionEditor',
  props: {
    value: {
      type: String,
    },
    buttons: {
      type: String,
      default: 'insertImage,insertVideo,|,insertCode,|,insertHeader,|,bold,strikethrough,underline,italic,|,superscript,subscript,|,align,ul,ol,|,outdent,indent',
    }
  },
  components: {
    AddImageDialog,
    AddMovieDialog,
  },
  mounted() {
    const textarea = this.$el.querySelector('textarea')
    if (!textarea) {
      return
    }
    this.editor = new Jodit(textarea, {
      toolbarAdaptive: false,
      buttons: this.buttons,
      disablePlugins: 'imageproperties,resizer',
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      showCharsCounter: false,
      showWordsCounter: false,
      defaultActionOnPaste: 'insert_clear_html',
      link: {
        openInNewTabCheckbox: false,
        noFollowCheckbox: false,
        processPastedLink: false,
      },
      controls: {
        insertHeader: {
          name: 'insertHeader',
          icon: 'paragraph',
          exec: function (editor: IJodit) {
            editor.execCommand('formatBlock', false, 'h2')
          },
        },
        insertImage: {
          name: 'insertImage',
          icon: 'image',
          exec: (editor: IJodit) => {
            this.savedSelection = editor.s.save()
            this.addImgDialog = true
          },
        },
        insertVideo: {
          name: 'insertVideo',
          icon: 'video',
          exec: (editor: IJodit) => {
            this.savedSelection = editor.s.save()
            this.addMovieDialog = true
          },
        },
        insertCode: {
          name: 'Code',
          exec: (editor: IJodit) => {
            editor.s.insertHTML('<pre>Enter code here</pre>')
          },
        },
      },
    })

    this.editor.value = this.value;
    this.refreshCharactersCount(this.value);

    this.editor.events.on('processPaste', (e: any, text: string) => {
      const sanitizedHtml = sanitizeHtml(text, {
        allowedTags: [
          'h2',
          'hr',
          'li',
          'ol',
          'p',
          'pre',
          'ul',
          'a',
          'abbr',
          'b',
          'br',
          'code',
          'em',
          'i',
          'small',
          'span',
          'strong',
          'sub',
          'sup',
          'u',
        ],
        transformTags: {
          td: 'p',
          th: 'p',
          h1: 'h2',
          h3: 'h2',
          h4: 'h2',
          h5: 'h2',
          h6: 'h2',
        },
      })

      return sanitizedHtml
    })

    this.editor.events.on('processPaste.link', this.onCustomProcessPasteLink);

    this.editor.events.on('change', (newValue: string) => {
      this.$emit('input', newValue);
      this.refreshCharactersCount(newValue);
    })
  },
  data: () => ({
    editor: {} as IJodit,
    addImgDialog: false,
    addMovieDialog: false,
    savedSelection: [] as markerInfo[],
  }),
  methods: {
    addUploadedImages: function (multimedia: Multimedia[]) {
      for (let i = 0; i < multimedia.length; i++) {
        const media = multimedia[i]
        const url = this.$options.filters
          ? this.$options.filters.multimediapath(media, '', 'size4')
          : ''
        this.editor.s.restore(this.savedSelection)
        const img = new Image()
        img.alt = media.name
        img.src = url
        this.editor.s.insertImage(img, null, '70%')
        this.editor.s.focus()
      }
    },
    addYoutubeMovie: function (multimedia: Multimedia) {
      this.editor.s.restore(this.savedSelection)
      this.editor.s.insertHTML(Youtube.getEmbedCode(multimedia.urls[0]))
      this.editor.s.focus()
    },
    refreshCharactersCount: function(value: string) {
      const cleanedHtml = sanitizeHtml(value, { allowedTags: [], allowedAttributes: {} });
      this.$emit('characterCountChange', cleanedHtml.length);
    },
    onCustomProcessPasteLink: function(e: ClipboardEvent, html: string): string | void {
      /* eslint-disable no-useless-escape */
      const aTagPattern = new RegExp(/<a\s[^>]*href=\"([^\"]*)\"[^>]*>(.*?)<\/a>/, 'gi') // $1 Group: href ([^\"]*), $2 Group: title (.*?)
      const httpLinkPattern = new RegExp(/(?:http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?#[\]@%!\$&'\(\)\*\+,;=.]+/, 'gi') // Groups: protocol, domain, query string
      /* eslint-enable no-useless-escape */

      // Parse <a> tag links pasted from clipboard
      if (aTagPattern.test(html)) {
        this.editor.e.stopPropagation('processPaste');
        return html.replaceAll(aTagPattern, '<a href="$1">$2</a>')
      }

      // Parse string http links (without <a> tag) pasted from clipboard
      else if (httpLinkPattern.test(html)) {
        this.editor.e.stopPropagation('processPaste');
        return html.replaceAll(httpLinkPattern, match => `<a href="${match}">${match}</a>`);
      }
    },
  },
})
